import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=4f7f33d4"
import script from "./Register.js?vue&type=script&lang=js&external"
export * from "./Register.js?vue&type=script&lang=js&external"
import style0 from "./Register.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports